import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import { Link } from 'react-router-dom';
import { FaArrowRightLong } from 'react-icons/fa6';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import useTitle from '../../Hooks/useTitle';


const Projects = () => {
    useTitle('Projects');
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('https://shakil-server.vercel.app/projects')
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                setProjects(data[1]);
            })
    }, [projects]);

    if (loading) {
        return <div className='flex justify-center items-center w-full min-h-[80vh] text-4xl'>
            <span className="loading text-accent loading-dots"></span>
        </div>
    }

    const initialSlideIndex = Math.floor(projects?.images.length / 2 - 1);

    return (
        <div className='px-5 md:px-20 lg:px-32 pb-10 md:pb-20 lg:pb-32 max-w-[1400px] m-auto'>
            <h1 className='font-bold text-4xl text-center mb-10 tracking-widest'>Latest <span className='text-teal-300'>Projects</span></h1>

            <div className='mt-20 mb-5 text-center'>
                        <Link to={`/projects/${projects?._id}`} className='text-2xl font-bold text-teal-400'>{projects?.name}</Link>
                        <br />
                        <Link to={`/projects/${projects?._id}`} className='btn btn-xs px-20 hover:border-teal-300 mt-5 btn-outline text-teal-500 w-10'>Details</Link>
                    </div>

            <div className='flex justify-center items-center py-5'>
                <Swiper
                    effect={"coverflow"}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={2}
                    spaceBetween={30}
                    coverflowEffect={{
                        rotate: 20,
                        stretch: 0,
                        depth: 700,
                        modifier: 1,
                        slideShadows: true,
                    }}
                    initialSlide={initialSlideIndex}
                    loop={true}
                    autoplay={{
                        delay: 1500,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay, EffectCoverflow]}
                    className="w-full"
                >
                    {
                        projects?.images.map(image => <SwiperSlide className="bg-center bg-cover w-full" key={image.id}>
                            <PhotoProvider>
                                <PhotoView src={image?.img}>
                                    <img src={image?.img} className='w-full block h-44 md:h-80 lg:h-80  rounded' alt="" />
                                </PhotoView>
                            </PhotoProvider>
                        </SwiperSlide>)
                    }
                </Swiper>
            </div>
            <div className='flex gap-4 md:gap-10 lg:gap-10 justify-center mt-10'>
                <Link to={projects?.liveServer} title={projects?.name} className='text-xs font-bold btn btn-sm  btn-accent md:px-12 lg:px-12' target='_blank'>Live Site</Link>

                <Link to={projects?.clientSite} title={projects?.name} className='text-xs font-bold btn btn-sm  btn-accent' target='_blank'>Client Site<span className='hidden md:block lg:block'>-Source Code</span></Link>
                {
                    projects?.serevrSite &&
                    <Link to={projects?.serevrSite} title={projects?.name} className='text-xs font-bold btn btn-sm  btn-accent' target='_blank'>Server Site<span className='hidden md:block lg:block'>-Source Code</span></Link>
                }
            </div>
            <div className='flex justify-center pt-20'>
                <Link to='/projects' className='btn btn-sm btn-outline hover:border-teal-300 text-teal-300'>See All Projects <FaArrowRightLong></FaArrowRightLong></Link>
            </div>
        </div>
    );
};

export default Projects;